import {axiosGetAuthorize, axiosPostAuthorize} from '../AxiosRequests';
import {GetMasterVendorsList, GetMasterVendorsById, GetSimilarVendorListByMapVendorId, UpdateMasterVendors,DeleteMasterVendors,GetDeletedMasterVendorsList} from '../ApiEndPoints';
export default class MasterVendorServices{

    async getMasterVendorsList(request){
        return axiosPostAuthorize(GetMasterVendorsList, request);
    }

    async getMasterVendorsById(request){
        return axiosGetAuthorize(GetMasterVendorsById, request);
    }

    async getSimilarVendorListByMapVendorId(request){
        return axiosPostAuthorize(GetSimilarVendorListByMapVendorId, request);
    }
    async updateMasterVendors(request){
        return axiosPostAuthorize(UpdateMasterVendors, request);
    }
    async deleteMasterVendors(request){
        return axiosPostAuthorize(DeleteMasterVendors, request);
    }  
    async getDeletedMasterVendorsList(request){
        return axiosPostAuthorize(GetDeletedMasterVendorsList, request);
    }     
    
}